"use strict";

var _interopRequireWildcard3 = require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;

var _interopRequireDefault = require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

var _interopRequireWildcard2 = _interopRequireDefault(require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.object.keys.js");

var inventory = _interopRequireWildcard3(require("@/api/inventory"));

var product = _interopRequireWildcard3(require("@/api/product"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

var _vuex = require("vuex");

var _q = require("q");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      buttonLoading: false,
      isLoading: false,
      typeId: null,
      objData: {
        imei: null,
        modelId: null
      },
      agencyLevel: this.$store.getters.agencyLevel,
      totalRecord: 0,
      arrDevice: [],
      tableData: [],
      arrAcengy: {},
      agency: {
        lv1: null,
        lv2: null,
        lv3: null,
        lv4: null
      },
      total: 10,
      listQuery: {
        page: 1,
        limit: 10,
        dateFrom: null,
        dateTo: null
      },
      tableLoading: false,
      alert: {
        success: "",
        error: ""
      }
    };
  },
  computed: {
    arrModel: function arrModel() {
      var _this = this;

      var arr;
      this.arrDevice.forEach(function (item) {
        if (item.id == _this.typeId) {
          arr = item.devices;
        }
      });
      return arr;
    }
  },
  created: function created() {
    this.getAgencyRoot();
    this.getTableData();
  },
  mounted: function mounted() {},
  watch: {
    "objData.imei": function objDataImei(val) {
      var arr = val.split("\n");
      var res = arr.filter(function (item) {
        if (item) return item;
      });
      this.totalRecord = res.length;
    },
    "agency.lv1": function agencyLv1(val) {
      this.getAgency(val, 2);
    },
    "agency.lv2": function agencyLv2(val) {
      this.getAgency(val, 3);
    },
    "agency.lv3": function agencyLv3(val) {
      this.getAgency(val, 4);
    },
    "agency.lv4": function agencyLv4() {}
  },
  methods: {
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },
    viewDetail: function viewDetail(status, batchId) {
      var _this2 = this;

      this.tableLoading = true;
      var tHeader = ["Imei", "Asign to User ID"];
      var filterVal = ["imei", "receiverName"];

      if (status == "FAIL") {
        tHeader.push("Error Type");
        filterVal.push("cause");
      }

      inventory.detailHistory(status, batchId).then(function (res) {
        Promise.resolve().then(function () {
          return (0, _interopRequireWildcard2.default)(require("@/vendor/Export2Excel"));
        }).then(function (excel) {
          var list = res.data;

          var data = _this2.formatJson(filterVal, list);

          excel.export_json_to_excel({
            header: tHeader,
            data: data,
            filename: ""
          });
          _this2.tableLoading = false;
        });
      }).finally(function () {
        _this2.tableLoading = false;
      });
    },
    getAgencyRoot: function getAgencyRoot() {
      var _this3 = this;

      inventory.getAgencyRoot().then( /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(res) {
          return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  res.data.forEach(function (element) {
                    if (!_this3.arrAcengy["lv".concat(element.agencyLevelId)]) {
                      _this3.arrAcengy["lv".concat(element.agencyLevelId)] = [];
                    }

                    _this3.arrAcengy["lv".concat(element.agencyLevelId)].push(element);
                  });
                  _context.next = 3;
                  return _this3.$nextTick();

                case 3:
                  if (_this3.arrAcengy.lv1) {
                    _this3.agency.lv1 = _this3.arrAcengy.lv1[0].id;
                  }

                  _context.next = 6;
                  return _this3.$nextTick();

                case 6:
                  if (_this3.arrAcengy.lv2) {
                    _this3.agency.lv2 = _this3.arrAcengy.lv2[0].id;
                  }

                  _context.next = 9;
                  return _this3.$nextTick();

                case 9:
                  if (_this3.arrAcengy.lv3) {
                    _this3.agency.lv3 = _this3.arrAcengy.lv3[0].id;
                  }

                  _context.next = 12;
                  return _this3.$nextTick();

                case 12:
                  if (_this3.arrAcengy.lv4) {
                    _this3.agency.lv4 = _this3.arrAcengy.lv4[0].id;
                  }

                  _this3.$forceUpdate();

                case 14:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    getAgency: function getAgency(parentId, level) {
      var _this4 = this;

      if (this.agencyLevel >= level) {
        while (level <= 4) {
          this.agency["lv".concat(level++)] = null;
        }

        return;
      }

      var data = {};
      this.isLoading = true;
      inventory.getAgency(parentId).then(function (res) {
        _this4.arrAcengy["lv".concat(level)] = res.data;

        while (level <= 4) {
          _this4.agency["lv".concat(level++)] = null;
        }

        _this4.$forceUpdate();
      }).finally(function () {
        _this4.isLoading = false;
      });
    },
    createData: function createData() {
      var _this5 = this;

      if (!this.objData.imei) {
        return this.$message({
          type: "error",
          message: "Imei is not empty"
        });
      }

      var arr = this.objData.imei.split("\n");
      var res = arr.filter(function (item) {
        if (item) return item;
      });
      var receiverId = null;
      Object.keys(this.agency).forEach(function (key) {
        if (_this5.agency[key]) {
          receiverId = _this5.agency[key];
        }
      });
      var data = {
        imei: res,
        receiverId: receiverId
      };
      this.buttonLoading = true;
      this.alert.success = "";
      this.alert.error = "";
      inventory.asign(data).then(function (res) {
        _this5.getTableData();

        _this5.objData.imei = "";
        _this5.alert.success = res.data.success;
        _this5.alert.error = res.data.fail;
      }).finally(function () {
        _this5.buttonLoading = false;
      });
    },
    getTableData: function getTableData() {
      var _this6 = this;

      this.tableLoading = true;
      inventory.history(this.listQuery).then(function (res) {
        _this6.tableData = res.data.data;
        _this6.total = res.data.total;
      }).finally(function () {
        _this6.tableLoading = false;
      });
    },
    getAllDevice: function getAllDevice() {
      var _this7 = this;

      device.getAllDevice().then(function (res) {
        _this7.arrDevice = res.data;
      });
    }
  }
};
exports.default = _default;